export default __webpack_public_path__ + "static/media/mp3icon.1a6623ff.svg";